import { render, staticRenderFns } from "./ImportItem.vue?vue&type=template&id=3fb5a0c5&scoped=true"
import script from "./ImportItem.vue?vue&type=script&lang=js"
export * from "./ImportItem.vue?vue&type=script&lang=js"
import style0 from "./ImportItem.vue?vue&type=style&index=0&id=3fb5a0c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5a0c5",
  null
  
)

export default component.exports